import { createI18n } from 'vue-i18n'
import en from '../locales/en.json'
import ms from '../locales/ms.json'
import id from '../locales/id.json'

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem('user-language') || 'en'

const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    ms,
    id
  }
})

export default i18n
